/**
 * Launcher for Desktop/Mobile 3rdParty games
 */

// TODO need removed this file after Core Merge 24.7.4.0

define(function(require, exports, module) {
    'use strict';

    const BasePlatform = require('modules/launcher/platforms/base.platform');
    const LauncherWindowView = require('modules/launcher/launcher.window.view');
    const _ = require('underscore');
    const url = require('util/url.util');
    const config = require('config');
    const historyUtil = require('util/history.util');
    const storage = require('util/storage.util');

    module.exports = _.extend({}, BasePlatform, {

        navigateFromLaunchGamePath: function() {
            const gamesPageUrl = storage.session.getItem('gamesPageUrl');
            const { prevPath } = historyUtil.state?.state || {};

            if (url.isLaunchGamePath()) {
                storage.session.removeItem('gamesPageUrl');

                Playtech.API.common.replace(gamesPageUrl || prevPath || config.get('rootPage'));
            }
        },

        /**
         * [launchInNewWindow Open game in new window by redirect]
         * @param  {Object} [options]
         * @param  {String} [type]    [Method Launch Type]
         */
        launchInNewWindow: function(options, type) {
            const launchOptions = type === 'wrapper'
                ? this.prepareWrapperUrl(options)
                : this.prepareRedirectUrl(options);

            new LauncherWindowView(launchOptions);

            if (url.isLaunchGamePath()) {
                this.navigateFromLaunchGamePath();
            }
        }
    });
});
